import { CheckboxGroupField, CheckboxGroupFieldProps } from '@cademy-ui/form';
import { FunctionComponent, useMemo } from 'react';

export type CustomCheckboxGroupFieldProps = Omit<CheckboxGroupFieldProps<string>, 'options'> & {
    options: string[];
};

export const CustomCheckboxGroupField: FunctionComponent<CustomCheckboxGroupFieldProps> = ({
    options,
    ...props
}) => {
    const checkboxOptions: CheckboxGroupFieldProps<string>['options'] = useMemo(() => {
        return options.map((option) => {
            return {
                value: option,
                label: option,
            };
        });
    }, [options]);

    return <CheckboxGroupField options={checkboxOptions} {...props} />;
};
